<template>
  <el-tooltip
    effect="dark"
    placement="bottom">
    <el-popover
      placement="bottom-end"
      width="700"
      trigger="click">
      <el-table
        :data="orderList.filter(data => !search || data.roomCode.toLowerCase().includes(search.toLowerCase()) || data.contactInformation.toLowerCase().includes(search.toLowerCase()) )"
        max-height="400">
        <el-table-column label="注册手机">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.contactInformation }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column property="name" label="房间编号">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.roomCode }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="联系方式或房间编号"/>
          </template>
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="updateRechargeOrderById(scope.$index, scope.row ,orderList)">绑定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--      <el-button slot="reference">click 激活</el-button>-->
      <el-button
        class="d2-ml-0 d2-mr btn-text can-hover"
        type="text"
        slot="reference">
        <el-badge :value="orderList.length" class="item">
          <d2-icon
            name="bell"
            style="font-size: 20px"/>
        </el-badge>
      </el-button>
    </el-popover>
  </el-tooltip>
</template>

<script>
import { findRechargeOrderByParams, updateRechargeOrderById } from '@/api/rechargeOrder'
import qs from 'qs'

export default {
  data () {
    return {
      filename: __filename,
      search: '',
      orderList: [],
      loading: false
    }
  },
  computed: {
  },
  mounted () {
    let _this = this
    _this.findRechargeOrderByParams()
    setInterval(_this.findRechargeOrderByParams, 300000)
  },
  methods: {
    findRechargeOrderByParams () {
      console.log('findRechargeOrderByParams')
      let obj = {}
      obj.orderStatus = 1
      findRechargeOrderByParams(obj).then(res => {
        this.orderList = res.data
      }).catch(err => {
        this.$notify({
          title: '数据请求异常'
        })
        console.log('err', err)
      })
    },
    updateRechargeOrderById (index, row, rows) {
      let obj = {}
      obj.orderId = row.orderId
      obj.orderStatus = 0
      updateRechargeOrderById(qs.stringify(obj)).then(res => {
        rows.splice(index, 1)
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-log/index.vue"
}
</vue-filename-injector>
